<template>
    <table>
        <slot></slot>
    </table>
</template>

<script>
import { mapState } from 'vuex';
import getOffsetTop from '@/utilities/getOffsetTop';

export default {
    name: 'appearObjectTable',

    props: {
        once: { type: Boolean, default: true },
    },

    computed: {
        ...mapState('window', [
            'isTouch',
            'height',
        ]),
    },

    created() {
        this.show = false;
    },

    mounted() {
        this.$eventHub.$on('resize', this.resize);
        this.$eventHub.$on('update', this.update);

        this.resize();
    },

    beforeDestroy() {
        this.$eventHub.$off('resize', this.resize);
        this.$eventHub.$off('update', this.update);
    },

    methods: {
        resize() {
            if (this.isTouch) {
                this.show = true;
                this.$el.classList.add('is-appear');
            }

            this.offsetY = getOffsetTop(this.$el);
            this.trigger = this.offsetY - (this.height - (this.height * 0.15));
        },

        update() {
            if ((this.once && this.show) || this.isTouch) return;

            if (!this.show && this.$root.smoothScroll >= this.trigger) {
                this.show = true;
                this.$el.classList.add('is-appear');
            }

            if (!this.once) {
                if (this.show && this.$root.smoothScroll < this.trigger) {
                    this.show = false;
                    this.$el.classList.remove('is-appear');
                }
            }
        },
    },
};
</script>
